import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { RefObject, useEffect, useState } from 'react';

import styles from '../styles.module.scss';

const REFLOW_DURATION_MS = 50;
const VISIBLE_ANIMATION_DURATION_MS = 350;
const CARD_ANIMATION_DURATION_MS = 1700;

interface Props {
    ref: RefObject<HTMLDivElement|null>;
    cardRef: RefObject<HTMLImageElement|null>;
}

function useCompleteAnimation({ ref, cardRef }:Props) {
    const [isVisible, setIsVisible] = useState(true);
    const { replace, push } = useFlow();
    useEffect(() => {
        if (isVisible) {
            ref.current?.classList.remove(styles.none);
            const visibleTimeout = setTimeout(() => {
                ref.current?.classList.remove(styles.hide);
            }, REFLOW_DURATION_MS);
            const cardTimeout = setTimeout(() => {
                cardRef.current?.classList.add(styles.animate);
            }, VISIBLE_ANIMATION_DURATION_MS);
            const animationTimeout = setTimeout(() => {
                setIsVisible(false);
            }, CARD_ANIMATION_DURATION_MS);

            return () => {
                clearTimeout(visibleTimeout);
                clearTimeout(cardTimeout);
                clearTimeout(animationTimeout);
            };
        }
        ref.current?.classList.add(styles.hide);
        const timeout = setTimeout(() => {
            ref.current?.classList.add(styles.none);
        }, 400);
        return () => clearTimeout(timeout);
    }, [cardRef, isVisible, ref, replace, push]);
}

export default useCompleteAnimation;
